//src/components/OrdersExportButton.tsx
import { useMemo } from 'react';
import ExportXlsxButton from './ExportXlsxButton';
import { ORDERS_XLSX_COLUMNS, mapOrdersToRows, mapNotifsToOrders } from '../utils/ordersExport';
import type { Notification as OrderNotif } from '../types/Notification';
import type { ExcelColumn } from '../utils/excel';
import { defaultFilename } from '../utils/filename';

type Props = {
  source: OrderNotif[];
  filename?: string;
  className?: string;
};

// универсальный адаптер: массивный маппер -> маппер одного элемента
const asSingleMapper =
  <T, R>(fn: (arr: T[]) => R[]) =>
  (item: T) =>
    fn([item]);

const getTime = (o: any) => {
  const t = new Date(o.createdAt).getTime();
  return Number.isFinite(t) ? t : null;
};

export default function OrdersExportButton({ source, filename, className }: Props) {
  // приводим notifications -> OrdersTableOrder один раз
  const orders = useMemo(() => mapNotifsToOrders(source), [source]);
  const fn = filename ?? defaultFilename('orders');

  return (
    <ExportXlsxButton
      source={orders}
      filename={fn}
      sheetName="Orders"
      columns={ORDERS_XLSX_COLUMNS as ReadonlyArray<ExcelColumn>}
      map={asSingleMapper(mapOrdersToRows)}
      getTime={getTime}
      className={className}
    />
  );
}
